var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"position-relative carousel-home-item",attrs:{"height":"100%","width":"100%","tile":""}},[_c('a',{attrs:{"href":_vm.link,"target":_vm.target ? '_blank' : '_self'}},[_c('img',{staticClass:"d-block carousel-home-item-img",attrs:{"src":_vm.files +
        (_vm.mobile && _vm.img_mobile
          ? _vm.img_mobile + '?resize=1&w=600'
          : _vm.img_desktop + '?resize=1&w=1920')}})])])}
var staticRenderFns = []

export { render, staticRenderFns }